import Immutable from 'immutable';
import * as types from '../actionTypes/apiCallsActionTypes';
import { createReducer } from '../utils';

const initialStateValue = {
  data_ready: false,
  usage: [],
  periods: [],
  status: '',
  error: {},
};

const initialState = Immutable.fromJS(initialStateValue);


export default createReducer(initialState, {
  [types.REQUEST_API_CALLS_DETAILS]: state =>
    state.merge(initialStateValue),

  [types.RECEIVE_API_CALLS_DETAILS]: (state, action) => state.mergeDeep({
    data_ready: true,
    usage: action.usage,
    periods: action.periods,
    status: action.status,
    receipt: action.receipt,
  }),

  [types.REQUEST_API_CALLS_SUMMARY]: state =>
    state.merge(initialStateValue),

  [types.RECEIVE_API_CALLS_SUMMARY]: (state, action) => state.mergeDeep({
    data_ready: true,
    usage: action.usage,
    periods: action.periods,
    status: action.status,
    receipt: action.receipt,
  }),

  [types.SERVICE_ERROR]: (state, action) =>
    state.mergeDeep({ data_ready: true, error: action.error }),
});



// WEBPACK FOOTER //
// ./src/redux/reducers/integrationsReducer.js